import { Component, Inject, Mixins } from '@/vue-property-decorator'
import { GetCssVarManager } from '@/views/game/components/gameCardSuit/components/baseCssVarProvide'
import { _LogoHasBackgroundBase as LogoHasBackgroundBase } from './cssVar/logoHasBackgroundBase'
import { _LogoHasBackgroundDefault as LogoHasBackgroundDefault } from './cssVar/logoHasBackgroundDefault'
import { SquareProps } from '../../basePropsConfig'
import BaseCssVarInject from '../../../../../components/baseCssVarInject'
import style from './style.module.scss'
export { LogoHasBackgroundBase, LogoHasBackgroundDefault }
export type LogoHasBackgroundCssVarManager =
  GetCssVarManager<LogoHasBackgroundBase>
/** 带有背景色的右下角log */
@Component<LogoHasBackground>({ name: 'LogoHasBackground' })
export default class LogoHasBackground extends Mixins<
  BaseCssVarInject<LogoHasBackgroundBase>
>(BaseCssVarInject) {
  /** 获得默认样式 */
  public static getCssVarDefault = () => new LogoHasBackgroundDefault()

  /** 接收根级传入的Props */
  @Inject() cardProps!: Required<SquareProps>

  /** 渲染 */
  render() {
    const { logoUrl } = this.cardProps
    // 如果没有图片路径则直接返回,啥也不渲染
    if (!logoUrl) {
      return <template></template>
    }
    return (
      <div
        class={{
          ['logo-has-background']: true,
          [style[`type-${this.finialCssType}`]]: Boolean(this.finialCssType),
          [style['logo-has-background']]: true
        }}
      >
        <div class={style['logo-background']}></div>
        <my-img
          class={{
            ['logo-icon']: true,
            [style['logo-icon']]: true
          }}
          src={logoUrl}
          options={{ type: 'div' }}
        />
      </div>
    )
  }
}
